import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CombineComponent } from './combine.component';
import { FormsModule }   from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from '@uppy/angular';

@NgModule({
  imports: [CommonModule, FormsModule,
    DragDropModule,
    SharedModule,
    DashboardComponent],
  declarations: [CombineComponent],
  exports: [CombineComponent,
    DragDropModule
  ]
})

export class CombineModule { }
